module.exports = __webpack_public_path__ + "static/pic10-7a557a8a75a35d1bfec65bba7fe9b43e.jpg";